import {atom} from "jotai";

export const categoryDescriptionAtom = atom<any>("")